import styled from 'styled-components';

export const ResourceSubmissionPermissionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

interface ResourceSubmissionPermissionsContainerProps {
  isError?: boolean;
}

export const ResourceSubmissionPermissionsContainer = styled.div<ResourceSubmissionPermissionsContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({ isError }) =>
    isError &&
    `
      border: 1px solid var(--color-error);
    `}
`;

export const ResourceSubmissionPermissionsItemContainer = styled.button.attrs({ type: 'button' })`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

export const ResourceSubmissionPermissionsItemLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

//RADIO CHECKBOX
export const ResourceSubmissionPermissionsRadioCheckboxContainer = styled.div`
  min-width: 16px;
  min-height: 16px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  border: 2px solid rgba(23, 28, 51, 0.3);
  background: #fff;
`;

export const ResourceSubmissionPermissionsRadioCheckbox = styled.div`
  width: 8px;
  height: 8px;

  border-radius: 100%;
  background: var(--color-data-people-foreground);
`;
